module.exports = ".padding-bottom-box{padding-bottom:15px !important}.padding-top-box{padding-top:15px !important}\n"